import { useState, useEffect, memo, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import RouteWrapper from "./components/wrapper/RouteWrapper";
import { AuthProvider } from "./provider/useAuth";
import { debounce } from "./utils/debounce";
import { routeConfig } from "./config/route-config";
import { TrackerTimeProvider } from "./provider/useTrackerTime";

const Header = lazy(() => import("./components/Header"));
const Footer = lazy(() => import("./components/Footer"));

export const MainLayout = memo(function MainLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleHamburgerClick = () => setSidebarCollapsed((prev) => !prev);
  const studentId = sessionStorage.getItem("id");
  const role = sessionStorage.getItem("role");
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
     const handleResize = debounce(() => {
      setWindowWidth(window.innerWidth);
    }, 200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getMarginLeft = () => {
    if (windowWidth <= 768) return 0;
    return sidebarCollapsed ? 70 : 250;
  };

  return (
    <TrackerTimeProvider studentId={studentId} role={role}>
      <div id="layout-wrapper1" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header collapsed={sidebarCollapsed} onHamburgerClick={handleHamburgerClick} />
        <div className="vertical-overlay"></div>
        <motion.div
          className="main-content"
          style={{
            marginLeft: getMarginLeft(),
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
          animate={{
            marginLeft: getMarginLeft()
          }}
          transition={{
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1]
          }}
        >
          <div className="page-content" style={{ flex: 1 }}>
            <div className="container-fluid">{children}</div>
          </div>
          <Footer />
        </motion.div>
      </div>
    </TrackerTimeProvider>
  );
})

// Animated Routes Component
function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        {routeConfig.map(({ path, component: Component, isProtected, isPublic, layout, allowedRoles }) => (
          <Route
            key={path}
            path={path}
            element={
              <RouteWrapper protectedRoute={isProtected} publicRoute={isPublic} withMainLayout={layout} allowedRoles={allowedRoles}>
                <Component />
              </RouteWrapper>
            }
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
}

function App() {

  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
    console.warn = function () {};
    // console.error = function () {};
  }

  return (
    <AuthProvider>
      <Router>
        <AnimatedRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;